import "@/App.css";
import "lenis/dist/lenis.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BrandProvider } from "@/lib/brand";
import { LangProvider } from "@/lib/i18n";
import Home from "@/pages/Home";
import AdminLogin from "@/pages/AdminLogin";
import Admin from "@/pages/Admin";
import QuoteWizard from "@/pages/QuoteWizard";

function App() {
  return (
    <BrandProvider>
      <LangProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/quote" element={<QuoteWizard />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </BrowserRouter>
      </LangProvider>
      <Toaster theme="dark" position="top-center" />
    </BrandProvider>
  );
}

export default App;
